import {FormFields} from '@shared/modules/form/interfaces/form-fields.infterface';

export const getLoginFormFields: FormFields = {
  email: {
    id: 'email',
    label: 'Adres e-mail',
    type: 'email',
    placeholder: 'Wprowadź adres e-mail',
    required: true,
  },
  password: {
    id: 'password',
    label: 'Hasło',
    type: 'password',
    placeholder: 'Wprowadź hasło',
    required: true,
  }
};
